export default __webpack_public_path__ + "static/media/pills@2x.d3930ba9.png";